import { connect } from 'react-redux'
import NewsletterWidget from '../../components/NewsletterWidget'
import { suscribeNewsletter, clearNewsletterState } from '../../actions/newsletterWidget';

const mapStateToProps = (state, ownProps) => {
  return {
    newsletter_error: state.newsletterWidget.error,
    newsletter_error_message: state.newsletterWidget.error_message,
    newsletter_sending: state.newsletterWidget.sending
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
  	onSuscribeNewslleter: (email) => dispatch(suscribeNewsletter(email)),
		onClearNewsletterState: () => dispatch(clearNewsletterState())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewsletterWidget)



// WEBPACK FOOTER //
// ./src/containers/NewsletterWidget/index.js